import HCRender from "../hc-render"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const Header = ({ searchState, onSearchResultSelect }) => {
  const Search = HCRender.getFragment("Search")
  const texts = TextBundle({ id: "help-center" })

  return (
    <div className="header-container w-full">
      <div className="relative w-full max-w-w2_xl md:h-[290px] rounded-[30px] md:rounded-[50px] bg-gradient-to-br from-primary/30 via-secondary/20 to-primary_lt/40 border border-primary/10 mt-6 md:mt-12 mx-auto">
        <div className="relative w-full h-full flex flex-col items-center justify-center z-20 mx-auto">
          <Typography
            variant="h1" 
            className="text-3xl text-text text-center mb-8"
          >
            {texts?.header_title || "How can we help you?"}
          </Typography>
          {Search && (
            <Search searchState={searchState} onResultSelect={onSearchResultSelect} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
